import { render } from "./realtor.vue?vue&type=template&id=0f98da2a&scoped=true"
import script from "./realtor.vue?vue&type=script&lang=js"
export * from "./realtor.vue?vue&type=script&lang=js"

import "./realtor.vue?vue&type=style&index=0&id=0f98da2a&scoped=true&lang=css"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f98da2a"]])

export default __exports__